<template>
  <div class="min-h-screen w-full bg-gray-600 flex items-center justify-center">
    <img src="/images/logo.png" class="h-48" alt="Casa Auto">
  </div>
</template>

<script>
  export default {
    metaInfo() {
      return {
        title: this.__("Pending")
      }
    },
    mounted() {
      window.Echo.private('consent-signing.' + this.$page.props.auth.user.id)
        .listen('ConsentSendToBeSignedEvent', (data) => {
          this.$inertia.visit(this.route('consents.edit', {consent: data.id}));
        });
    }
  }
</script>
